<spe-alert [class]="apiStatus" [message]="message"></spe-alert>

<div class="row align-items-center" [hidden]="(loading$ | async) || isEmpty">
  <div class="col-lg-4">
    <spe-titulo-sessao
      [titulo]="`${totalElements} ocorrência${totalElements === 1 ? '' : 's'}`"
      [icone]="'assets/icones/cinza/historico.svg'"
    ></spe-titulo-sessao>
  </div>

  <div class="col-lg-8">
    <div class="hstack gap-3 justify-content-lg-end search-container">
      <mat-chip-set class="rounded-mat-chip" aria-label="Filtros ativos" *ngIf="activeFilters.length">
        <mat-chip
          *ngFor="let filter of activeFilters; trackBy: trackByActiveFilter"
          [removable]="true"
          (removed)="clearFilter(filter.key)"
        >
          {{ getFilterLabel(filter.key, filter.value) }}
          <mat-icon class="color-brand-principal" matChipRemove>close</mat-icon>
        </mat-chip>
      </mat-chip-set>

      <spe-table-search-bar
        [(inputValue)]="inputValue"
        [(showSearchBar)]="showSearchBar"
        (applySearchFilter)="applySearchFilter()"
      ></spe-table-search-bar>

      <spe-table-filter-menu [filtersCount]="activeFilters.length">
        <ng-template #filterContent>
          <form [formGroup]="filtersForm">
            <section>
              <h6 class="mb-8">Status</h6>
              <mat-radio-group formControlName="idStatusOcorrencia">
                <ul class="list-unstyled mb-0">
                  <li><mat-radio-button [value]="null">Todos</mat-radio-button></li>
                  <li *ngFor="let status of listaStatusOcorrencia">
                    <mat-radio-button [value]="status.idStatusOcorrencia">
                      {{ status.descricaoStatusOcorrencia }}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </section>

            <section class="mt-16">
              <h6 class="mb-8">Tipo</h6>
              <mat-radio-group formControlName="idTipoOcorrencia">
                <ul class="list-unstyled mb-0">
                  <li><mat-radio-button [value]="null">Todos</mat-radio-button></li>
                  <li *ngFor="let tipo of listaTipoOcorrencia">
                    <mat-radio-button [value]="tipo.idTipoOcorrencia">
                      {{ tipo.descricaoTipoOcorrencia }}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </section>

            <section class="mt-16">
              <h6 class="mb-8">Origem</h6>
              <mat-radio-group formControlName="idOrigemOcorrencia">
                <ul class="list-unstyled mb-0">
                  <li><mat-radio-button [value]="null">Todas</mat-radio-button></li>
                  <li *ngFor="let origem of listaOrigemOcorrencia">
                    <mat-radio-button [value]="origem.idOrigemOcorrencia">
                      {{ origem.descricaoOrigemOcorrencia }}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </section>
          </form>
        </ng-template>

        <ng-template #filterFooter>
          <button (click)="clearAllFilters()" mat-flat-button class="w-100">Limpar filtros</button>
        </ng-template>
      </spe-table-filter-menu>

      <form [formGroup]="filtersForm">
        <mat-chip-listbox formControlName="diasAbertura">
          <mat-chip-option *ngFor="let dia of listaDiasAbertura" [value]="dia"> {{ dia }} dias </mat-chip-option>
        </mat-chip-listbox>
      </form>
    </div>
  </div>
</div>

<spe-skeleton-card [hidden]="!(loading$ | async)" [noBody]="true" />

<spe-skeleton-table
  [displayedColumns]="['Número', 'Data de abertura', 'Tipo', 'Status', 'Opções']"
  [hidden]="!(loading$ | async)"
/>

<spe-empty-list
  *ngIf="isEmpty && !(loading$ | async)"
  [iconPath]="'/assets/icones/cinza/historico.svg'"
  [title]="'Você não tem ocorrências'"
  [subtitle]="'Abra sua primeira ocorrência.'"
  [linkText]="'Quando preciso abrir uma ocorrência?'"
  [linkUrl]="''"
  [buttonText]="''"
  [dialogInfoData]="emptyListDialogInfoData"
></spe-empty-list>

<div [hidden]="(loading$ | async) || isEmpty">
  <div class="overflow-x-auto rounded-16">
    <table mat-table matSort spe-table [dataSource]="dataSource">
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Número</th>
        <td mat-cell *matCellDef="let row" data-label="Número">{{ row.idOcorrencia }}</td>
      </ng-container>

      <ng-container matColumnDef="dataAbertura">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de abertura</th>
        <td mat-cell *matCellDef="let row" data-label="Data de abertura">{{ row.dtAbertura | date: 'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row" data-label="Tipo">{{ row.tipoOcorrencia }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row" data-label="Status">
          <span class="status-chip" [ngClass]="getStatusClass(row.statusOcorrencia)">
            {{ row.statusOcorrencia }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="opcoes">
        <th mat-header-cell *matHeaderCellDef class="text-end">Opções</th>
        <td mat-cell *matCellDef="let row; dataSource: dataSource" data-label="Opções" class="text-end">
          <button [matMenuTriggerFor]="menu" mat-icon-button class="color-brand-principal">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="goToDetails(row)">Detalhar</button>
          </mat-menu>
        </td>
      </ng-container>

      <tr class="background" *matNoDataRow>
        <td class="pt-24 pb-24" colspan="5">Nenhuma ocorrência encontrada</td>
      </tr>
    </table>
  </div>

  <mat-paginator
    *ngIf="totalElements > 0"
    showFirstLastButtons
    class="mt-16"
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="currentPage"
    [pageSizeOptions]="[25, 50, 100]"
    (page)="pageEvents($event)"
  >
  </mat-paginator>
</div>
